import { SKIP } from './Constants';

/**
 * Generates the header list for the import preview table. Columns that do not have
 * a field associated with it will default to a Skip field.
 *
 * @param {Array{Object}} selectedFieldList fields corresponding to columns, these should not include skipped columns
 * @param {Number} numberOfColumns number of columns in the table
 */
export const generateHeaderList = (selectedFieldList, numberOfColumns) => {
  const headerList = [];
  let fieldListPointer = 0;

  for (let i = 0; i < numberOfColumns; i++) {
    const field = selectedFieldList[fieldListPointer];

    if (field && field.ColumnNumber === i) {
      headerList.push({
        ColumnNumber: field.ColumnNumber,
        FieldName: field.ColumnLabel,
        ColumnLabel: field.ColumnLabel,
      });
      fieldListPointer += 1;
    } else {
      headerList.push({
        ColumnNumber: i,
        FieldName: SKIP,
        ColumnLabel: SKIP,
      });
    }
  }

  return headerList;
};



// WEBPACK FOOTER //
// ./src/common/Components/ImportPreview/helpers/index.js